import { useEffect, useState } from 'react';

import { Box } from '@chakra-ui/react';

import { AutoResizeInput } from 'uiToolkitV1/AutoResizeInput';
import { ConfirmationModal } from 'uiToolkitV1/ConfirmationModal';
import { TextLabel } from 'uiToolkitV1/Typography';

import type { DisciplinaryNoteRow } from '../MyCompanyDisciplinaryActionsGrid';

type DenyAllConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  selectedNoteIds: number[];
  rows: DisciplinaryNoteRow[];
  onConfirm: (noteIds: number[], reason: string) => void;
  isDenying?: boolean;
};

export const DenyAllConfirmationModal = ({
  isOpen,
  onClose,
  selectedNoteIds,
  rows,
  onConfirm,
  isDenying = false,
}: DenyAllConfirmationModalProps) => {
  const [reason, setReason] = useState('');
  const selectedNotes = rows.filter((note) => selectedNoteIds.includes(note.NOTE_ID));
  const createdNotes = selectedNotes.filter((note) => note.STATUS === 'CREATED');

  // Reset reason when modal is closed
  useEffect(() => {
    if (!isOpen) {
      setReason('');
    }
  }, [isOpen]);

  const handleConfirm = () => {
    onConfirm(
      createdNotes.map((note) => note.NOTE_ID),
      reason
    );
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      title="Deny"
      body={
        <>
          <Box mb="4 !important">{`Do you want to deny all ${createdNotes.length} disciplinary notes?`}</Box>
          <TextLabel mb="2px" color="text.g2">
            Reason for denial
          </TextLabel>
          <AutoResizeInput
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Add comments here..."
            isDashed
            minH="224px"
            maxH="224px"
            _placeholder={{ color: 'text.g3' }}
            disabled={isDenying}
          />
        </>
      }
      cancelText="Cancel"
      onCancel={onClose}
      continueText={isDenying ? 'Denying...' : 'Deny'}
      onContinue={handleConfirm}
      disabled={false}
      primaryActionButtonColor="red"
      modalContentProps={{ w: '600px' }}
      cancelButtonProps={{
        variant: 'outlined',
        isDisabled: isDenying,
      }}
      continueButtonProps={{
        disabled: createdNotes.length === 0 || reason.trim().length === 0 || isDenying,
      }}
    />
  );
};
